import http from '../api/httpRequest.js'
import {TERMINAL_TYPE} from "../api/enums.js"

export default {

	state: {
		friends: [],
		friendRequest: [],
		timer: null
	},
	mutations: {
		setFriends(state, friends) {
			friends.forEach((f)=>{
				f.online = false;
				f.onlineWeb = false;
				f.onlineApp = false;
			})
			state.friends = friends;
		},
		setFriendRequest(state, friendRequest) {
			state.friendRequest = friendRequest;
		},
		updateFriend(state,friend){
			state.friends.forEach((f,index)=>{
				if(f.id==friend.id){
					// 拷贝属性
					let online = state.friends[index].online;
					Object.assign(state.friends[index], friend);
					state.friends[index].online =online;
					state.friends[index].friendRemark = friend.friendRemark;
				}
			})
		},
		setFriendDnd(state, {friendId, isDnd}) {
			state.friends.forEach((f, index) => {
				if (f.id == friendId) {
					state.friends[index].isDnd = isDnd;
				}
			})
		},
		updateFriendRequest(state, friendRequest) {
			state.friendRequest.forEach((item, index)=>{
				if(item.id===friendRequest.id){
					// 拷贝属性
					Object.assign(state.friendRequest[index], friendRequest);
				}
			})
		},
		removeFriend(state, id) {
			const idx = state.friends.findIndex(f => f.id === id);
			if (idx !== -1) {
				state.friends[idx].deleted = true;
			}
		},
		addFriend(state, friend) {
			const idx = state.friends.findIndex(f => f.id === friend.id);
			if (idx !== -1) {
				state.friends[idx].deleted = false;
			} else {
				state.friends.push(friend);
			}
		},
		addFriendRequest(state, friendRequest) {
			state.friendRequest.push(friendRequest);
		},
		refreshOnlineStatus(state){
			let userIds = [];
			if(state.friends.length ==0){
				return;
			}
			state.friends.forEach((f)=>{userIds.push(f.id)});
			http({
				url: '/user/terminal/online',
				method: 'get',
				params: {userIds: userIds.join(',')}
			}).then((onlineTerminals) => {
				this.commit("setOnlineStatus",onlineTerminals);
			})

			// 30s后重新拉取
			state.timer && clearTimeout(state.timer);
			state.timer = setTimeout(()=>{
				this.commit("refreshOnlineStatus");
			},30000)
		},
		setOnlineStatus(state,onlineTerminals){
			state.friends.forEach((f)=>{
				let userTerminal = onlineTerminals.find((o)=> f.id==o.userId);
				if(userTerminal){
					f.online = true;
					f.onlineTerminals = userTerminal.terminals;
					f.onlineWeb = userTerminal.terminals.indexOf(TERMINAL_TYPE.WEB)>=0
					f.onlineApp = userTerminal.terminals.indexOf(TERMINAL_TYPE.APP)>=0
				}else{
					f.online = false;
					f.onlineTerminals = [];
					f.onlineWeb = false;
					f.onlineApp = false;
				}
			});
			// 在线的在前面
			state.friends.sort((f1,f2)=>{
				if(f1.online&&!f2.online){
					return -1;
				}
				if(f2.online&&!f1.online){
					return 1;
				}
				return 0;
			});
		},
		clear(state) {
			state.timer && clearTimeout(state.timer);
			state.friends = [];
			state.timer = null;
		}
	},
	getters: {
		getFriendRequest: (state) => () => {
			return state.friendRequest;
		},
		friendMsgDnd: (state) => (friendId) => {
			let friend = state.friends.find(item => item.id === friendId);
			if (friend) {
				return friend.isDnd;
			}
			return false;
		},
		isFriend: (state) => (userId) => {
			return state.friends.some(f => f.id === userId);
		},
	},
	actions: {
		loadFriend(context) {
			return new Promise((resolve, reject) => {
				http({
					url: '/friend/list',
					method: 'GET'
				}).then((friends) => {
					context.commit("setFriends", friends);
					context.commit("refreshOnlineStatus");
					console.log("loadFriend")
					resolve()
				}).catch((res) => {
					reject();
				})
			});
		}
	}
}
